import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    vehicleStatus: {
      borderRadius: 2,
      color: '#fff',
      fontSize: '12px',
      fontWeight: 500,
      padding: '6px 16px',
      position: 'relative',
    },
    inshop: {
      backgroundColor: theme.palette.grey[500],
    },
    active: {
      backgroundColor: theme.palette.status.active,
    },
    retired: {
      backgroundColor: theme.palette.grey[500],
    },
    inactive: {
      backgroundColor: theme.palette.grey[500],
    },
    vehicleLink: {
      fontSize: theme.typography.pxToRem(13),
      lineHeight: 1.25,
      fontWeight: 500,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
        fontWeight: 500,
      },
    },
    link: {
      fontWeight: 500,
      color: theme.palette.text.primary,
      '& a': {
        cursor: 'pointer',
        color: theme.palette.text.primary,
      },
    },
    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
    },

    textRight: {
      textAlign: 'right',
    },

    updateVehicle: {
      margin: '12px 0',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    vehicleImg: {
      maxWidth: '100%',
    },

    vehicleList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    vehicleListItem: {
      width: '100%',
      padding: '0 4px 0 0',
      borderBottom: '1px solid #EEE',

      '&:last-child': {
        border: 0,
      },
    },

    vehicleDivider: {
      margin: '7px -25px 0',
    },

    loadingContainer: {
      minHeight: 150,
      width: '100%',
    },

    errorContainer: {
      padding: '1.5rem 1.5rem 1.5rem 2rem',
    },
  };
});

const listStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      fontSize: 13,
      fontWeight: 500,
      color: '#4D4F5C',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      wordBreak: 'break-word',
      maxWidth: '70%',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    primary: {
      fontSize: 13,
      fontWeight: 400,
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

export { useStyles, listStyles, listTextStyles, customCardStyles };
